import Vue from 'vue'
import VueResource from 'vue-resource'
import * as types from './mutation-types'
// import store from './store'
import db from './db'

Vue.use(VueResource)

const actions = {
  initCategories ({commit}) {
    db.getCategories().then((response) => {
      let categories = response._source
      commit(types.UPDATE_CATEGORIES, { categories })
    })
  },
  queryProtocols ({commit}, query) {
    let params = {params: {q: query}}
    console.log(params)
    db.queryProtocols(params).then((response) => {
      let protocols = response.hits.hits
      commit(types.UPDATE_PROTOCOLS, { protocols })
    })
  }
}

const getters = {
  categories: state => {
    return state.categories
  }
}

export default {
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/actions.js